import React from 'react';
import { Switch, Route } from "react-router-dom";
import { connect } from "react-redux";
import { ROUTE_MAIN } from 'stores/constants';

import Dashboard from 'components/Dashboard/Dashboard';
import GlobalNotification from 'containers/GlobalNotification/GlobalNotification';
import GlobalLoader from 'containers/GlobalLoader/GlobalLoader';

import RouteNotFound from 'components/RouteNotFound/RouteNotFound';
import RoutePublic from "components/RoutePublic/RoutePublic";
import Footer from "components/Footer/Footer";
import Header from 'components/Header/Header';

import 'scss/app.scss';

class App extends React.Component {

    componentDidMount() {
    }

    render() {
        return (
            <>
                <GlobalNotification />
                <GlobalLoader />
                <Header />
                <div className='page'>
                    <Switch>
                        <RoutePublic path={ROUTE_MAIN} component={Dashboard} exact />
                        <Route path='*' component={RouteNotFound} exact />
                    </Switch>
                </div>
                <Footer />
            </>
        );
    }
}

App.propTypes = {};

export default connect(
    null,
    null,
)(App);